import { Box, SxProps, Theme } from '@mui/material';
import { ReactNode } from 'react';
import { useGetSidePadding } from './useGetSidePadding';

interface ConfigurationCanvasPanelContentProps {
  children: ReactNode;
  dataTestId?: string;
  sx?: SxProps<Theme>;
}

export const ConfigurationCanvasPanelContent: React.FC<ConfigurationCanvasPanelContentProps> = ({
  children,
  dataTestId,
  sx,
}) => {
  const sidePadding = useGetSidePadding();

  return (
    <Box
      data-testid={dataTestId}
      sx={{
        padding: `0 ${sidePadding}px`,
        flex: '1 1 auto',
        overflowY: 'visible',
        ...sx,
      }}
      className="configuration-canvas-panel-content"
    >
      {children}
    </Box>
  );
};
